import { Component, h } from 'preact';
import Candidate from './candidate';
import Countdown from './countdown';

import mergeWriteIns from '../utils/merge-write-ins';
import numberWithCommas from '../utils/number-with-commas';
import sortCandidates from '../utils/sort-candidates';
import sumValues from '../utils/sum-values';

class Race extends Component {
  render () {
    const race = this.props.race;

    if (!race) return null;

    const isPresident = (race.office_slug === 'us-president');
    const isScoreboard = this.props.scoreboard;
    const isOnHomepage = this.props.isOnHomepage;

    const candidates = isPresident ? mergeWriteIns(race.candidates) : race.candidates;
    const totalVotes = sumValues(candidates, 'votes');

    const candidatesOutput = sortCandidates(candidates).map((candidate) => {
      return <Candidate raceCalled={race.called} raceUncontested={race.uncontested} totalVotes={totalVotes} candidate={candidate} />;
    });

    const precincts = `${numberWithCommas(race.precincts_reporting)} of ${numberWithCommas(race.total_precincts)} precincts reporting (${race.precincts_reporting_percent.toFixed(1)}%)`;

    let countdown = null;

    if (this.props.timeLeft) {
      countdown = <Countdown timeLeft={this.props.timeLeft} />;
    }

    return (
      <div className="widget">
        <div className="race">
          {countdown}
          <table className="race__candidates">
            <caption>
              <div className="race__caption">
                <p className="race__title">{!isOnHomepage && race.office + ' — ' + race.district_display}</p>
                {isScoreboard && false && <label class="race__save"><input class="race__save-input" type="checkbox" value={race.id} />Save race</label>}
              </div>
            </caption>
            <thead>
              <tr>
                <th className="race__candidate-header" colspan="2">{isOnHomepage && 'Presidential'} Candidate</th>
                <th className="race__candidate-header race__candidate-header--numeric">{isPresident ? 'Votes in Texas' : 'Votes'}</th>
                <th className="race__candidate-header race__candidate-header--numeric">Pct.<span className="candidate__pct-symbol">%</span></th>
              </tr>
            </thead>
            <tbody>
              {(race.called && race.result !== 'not called') &&
              <tr class="race__called-row">
                <td colspan="4">{race.result === 'uncontested' ? null : 'Projected'} {isPresident ? `Texas ${race.result}` : race.result}</td>
              </tr>
              }
              {candidatesOutput}
            </tbody>
          </table>
          <div className="race__metrics">
            {this.props.includeFullResultsButton ? <a className="button button--yellow" href="https://elections.texastribune.org/2016/general-election-results/">View full election results &#187;</a> : <span></span>}
            <p className="race__precincts">{race.uncontested ? 'No totals reported in uncontested races' : precincts}</p>
          </div>
        </div>
      </div>
    );
  }
}

export default Race;



// WEBPACK FOOTER //
// ./components/race.js